// extracted by mini-css-extract-plugin
export default {"button-loader":"BqklZJB4vM_0JhAx3or5","button-loader-text":"uQ3J4t4PMEyxqGZ2uxRI"};